import { BaseMutations } from '@/store/base-mutations';
// import { default_lead } from '@/modules/leads/services';
import { Staffs } from '@/modules/staffs/types';
import AnalitycsListState from '@/modules/staffs/store/modules/staff-analitycs-list/state';

export default class AnalitycsListMutations extends BaseMutations<AnalitycsListState> {
  SET_STATISTICS(statistics: Staffs.StaffStatistic[]) {
    this.state.statistics = statistics;
  }

  TOGGLE_LOADING_STATISTICS(toggle: boolean) {
    this.state.statistics_loading = toggle;
  }
}
